class CaseService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/biobank/case-numbers';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ caseNumber }) {
    const { data } = await this.axios.post(this.url, caseNumber);
    return data;
  }

  async update({ caseNumber }) {
    const { data } = await this.axios.put(this.url, caseNumber);
    return data;
  }
}

export default CaseService;
